/* @flow */
import React, { Component } from 'react'

import HomeBanner from './HomeBanner/HomeBanner'
import ExplainerDiagram from './ExplainerDiagram/ExplainerDiagram'
import Heading from '../../Widgets/Heading/Heading'
import EmailFormContainer from '../../EmailFormContainer/EmailFormContainer'
import FormModal from '../../Widgets/FormModal/FormModal'

import headingDividerSmall from '../../../images/heading-divider-small.svg'
import secureBriefcase from '../../../images/icons/secure-briefcase.svg'
import handshake from '../../../images/icons/handshake.svg'
import chartScreen from '../../../images/icons/chart-screen.svg'
import risk from '../../../images/icons/risk.svg'
import automation from '../../../images/icons/automation.svg'
import rocket from '../../../images/icons/rocket.svg'
import book from '../../../images/icons/book.svg'
import direct from '../../../images/icons/direct.svg'
import network from '../../../images/icons/network.svg'
import identity from '../../../images/icons/identity.svg'
import dashedCircleAvatar from '../../../images/dashed-circle-avatar.svg'
import cialLogo from '../../../images/cial-d&b-logo.png'
import timelineConnector from '../../../images/timeline-connector.svg'
import greenLines from '../../../images/green-lines.png'

import johnPotter from '../../../images/team/john_potter.jpg'
import yoniCohen from '../../../images/team/yoni_cohen.jpg'
import ariCohen from '../../../images/team/ari_cohen.jpg'
import zvonimirBaljak from '../../../images/team/zvonimir_baljak.jpg'
import aaronLeibowitz from '../../../images/team/aaron_leibowitz.jpg'
import matejSerbec from '../../../images/team/matej_serbec.jpg'
import samuelBauer from '../../../images/team/samuel_bauer.jpg'
import janeLevy from '../../../images/team/jane_levy.jpg'

import whitepaper from '../../../files/novo_whitepaper.pdf'

import './Home.css'

type State = {
  contactFormOpen: boolean,
  contactFormParticipant: string,
}

export default class Home extends Component<{}, State> {

  state = {
    contactFormOpen: false,
    contactFormParticipant: '',
  }

  openContactForm = (e: SyntheticEvent<HTMLInputElement>, participantType: string) => {
    e.preventDefault()
    this.setState({contactFormOpen: true, contactFormParticipant: participantType})
  }

  closeContactForm = () => {
    this.setState({contactFormOpen: false})
  }

  render() {
    return (
      <div className='Home'>
        <FormModal open={this.state.contactFormOpen} handleClose={this.closeContactForm} participantType={this.state.contactFormParticipant} />
        <HomeBanner />
        <ExplainerDiagram openContactForm={this.openContactForm} />
        <div id="use_cases" className="landing-use-cases landing-section">
          <Heading text="How can the data be used?" />
          <div className="use-cases--content container">
            <div className="card">
              <div className="icon-container">
                <img src={secureBriefcase} />
              </div>
              <h3 className="small">Business Identity</h3>
              <img src={headingDividerSmall} className="heading-divider-small" />
              <p className="small">From Master Data Management to verifiying identity before a digital transaction, it all starts with ‘who’.</p>
            </div>
            <div className="card">
              <div className="icon-container">
                <img src={handshake} />
              </div>
              <h3 className="small">Finance & Credit</h3>
              <img src={headingDividerSmall} className="heading-divider-small" />
              <p className="small">More complete and accurate data at a global level will enable more informed decision making and financing.</p>
            </div>
            <div className="card">
              <div className="icon-container">
                <img src={chartScreen} />
              </div>
              <h3 className="small">Market Analysis</h3>
              <img src={headingDividerSmall} className="heading-divider-small" />
              <p className="small">Access comprehensive business data on any industry or geography from a single source.</p>
            </div>
            <div className="card">
              <div className="icon-container">
                <img src={risk} />
              </div>
              <h3 className="small">Risk Modeling</h3>
              <img src={headingDividerSmall} className="heading-divider-small" />
              <p className="small">Access more comprehensive risk scores and data in industries and geographies previously underserved.</p>
            </div>
            <div className="card">
              <div className="icon-container">
                <img src={automation} />
              </div>
              <h3 className="small">Process Automation</h3>
              <img src={headingDividerSmall} className="heading-divider-small" />
              <p className="small">Ensure that automated processes run smoothly by automatically checking identity and risk scores.</p>
            </div>
            <div className="card">
              <div className="icon-container">
                <img src={rocket} />
              </div>
              <h3 className="small">See more in the whitepaper</h3>
              <img src={headingDividerSmall} className="heading-divider-small" />
              <p className="small">Novo is designed in a way that allows it to be used for virtually any use case that demands accurate business data.</p>
            </div>
          </div>
        </div>
        <div id="about" className="landing-about landing-section">
          <div className="about-content container">
            <div className="about--qa">
              <div>
                <h3>What is Novo?</h3>
                <p>Novo (Network of Verified Organizations) is a blockchain-based marketplace for verified business data that directly connects commercial data providers and data buyers on a global level.</p>
              </div>
              <div>
                <h3>How does it work?</h3>
                <p>Novo enables the direct contribution of data securely to the blockchain. This allows any person or company to monetize their data directly. Our network of vetted verifiers ensure the data is truthful. Buyers can then purchase this verified data, with revenue being split between data providers and data verifiers.</p>
              </div>
            </div>
            <div className="about--cta">
              <div className="icon-container large">
                <img src={book} />
              </div>
              <h3>Learn more in the whitepaper</h3>
              <a href={whitepaper} target="_blank" className="button">READ WHITEPAPER</a>
            </div>
          </div>
        </div>
        <div id="partners" className="landing-partners landing-section">
          <Heading text="Our Partners" />
          <div className="partners-content container">
            <div className="partner">
              <a href="https://www.cialdnb.com/en/" target="_blank">
                <img className="partner--logo" src={cialLogo} />
              </a>
              <p>Cial Dun & Bradstreet is Latin America’s largest data provider. With a base of over 40 million companies, utilized by businesses all over the world, this partnership will enable Novo to launch as a leading data resource, expanding globally at a rapid pace.</p>
              <div className="metric-container">
                <div className="metric">
                  <span className="metric-primary">43</span>
                  <span className="metric-secondary">countries</span>
                </div>
                <div className="metric">
                  <span className="metric-primary">40m</span>
                  <span className="metric-secondary">companies tracked</span>
                </div>
                <div className="metric">
                  <span className="metric-primary">400k</span>
                  <span className="metric-secondary">updates per day</span>
                </div>
              </div>
            </div>
            <div className="secondary-cta">
              <div><a className="secondary-action" onClick={(e) => this.openContactForm(e, 'partner')}>BECOME A PARTNER <i className="icon icon-arrow-right-thick" /></a></div>
            </div>
          </div>
        </div>
        <div id="products" className="landing-products landing-section">
          <Heading text="Our Products" />
          <div className="use-cases--content container">
            <div className="card">
              <div className="icon-container">
                <img src={direct} />
              </div>
              <h3 className="small">Direct Access</h3>
              <img src={headingDividerSmall} className="heading-divider-small" />
              <p className="small">An enterprise solution for the sharing of sensitive data without a trusted third party.</p>
            </div>
            <div className="card">
              <div className="icon-container">
                <img src={identity} />
              </div>
              <h3 className="small">Novo ID</h3>
              <img src={headingDividerSmall} className="heading-divider-small" />
              <p className="small">A unique blockchain-based business identifier.</p>
            </div>
            <div className="card">
              <div className="icon-container">
                <img src={network} />
              </div>
              <h3 className="small">Bounty Marketplace</h3>
              <img src={headingDividerSmall} className="heading-divider-small" />
              <p className="small">Access to data on any company around the globe through a distributed network of providers and verifiers.</p>
            </div>
          </div>
        </div>
        {/* <div id="roadmap" className="landing-roadmap inverse">
          <Heading text="The Roadmap" />
          <div className="roadmap--content container">
            <div className="timeline--container">
              <div className="timeline--event">
                <div className="timeline--date">Q4 2018</div>
                <div className="timeline--marker-container">
                  <div className="timeline--marker timeline--marker-complete"></div>
                  <img className="timeline--connector" alt='' src={timelineConnector}/>
                </div>
                <div className="timeline--title">PRE-SALE</div>
              </div>
              <div className="timeline--event">
                <div className="timeline--date">Q1 2019</div>
                <div className="timeline--marker-container">
                  <div className="timeline--marker"></div>
                  <img className="timeline--connector" alt='' src={timelineConnector}/>
                </div>
                <div className="timeline--title">PUBLIC SALE</div>
              </div>
              <div className="timeline--event">
                <div className="timeline--date">Q2 2019</div>
                <div className="timeline--marker-container">
                  <div className="timeline--marker"></div>
                  <img className="timeline--connector" alt='' src={timelineConnector}/>
                  <img className="timeline--connector timeline--connector--both" alt='' src={timelineConnector}/>
                </div>
                <div className="timeline--title">PILOT LAUNCH</div>
              </div>
              <div className="timeline--event">
                <div className="timeline--date">Q4 2019</div>
                <div className="timeline--marker-container">
                  <div className="timeline--marker"></div>
                </div>
                <div className="timeline--title">PUBLIC LAUNCH</div>
              </div>
            </div>
          </div>
        </div>*/}
        {/* <div className="landing-blog landing-section">
          <Heading text="Learn more about Novo" />
          <div className="blog--content container">
            <div className="image-card">
              <div className="image-card--image" style={{backgroundImage: `url(${greenLines})`}}></div>
              <div className="image-card--content">
                <h3>Article Title</h3>
                <img src={headingDividerSmall} className="heading-divider-small" />
                <p>Words go here...</p>
              </div>
            </div>
            <div className="image-card">
              <div className="image-card--image" style={{backgroundImage: `url(${greenLines})`}}></div>
              <div className="image-card--content">
                <h3>Article Title</h3>
                <img src={headingDividerSmall} className="heading-divider-small" />
                <p>Words go here...</p>
              </div>
            </div>
            <div className="image-card">
              <div className="image-card--image" style={{backgroundImage: `url(${greenLines})`}}></div>
              <div className="image-card--content">
                <h3>Article Title</h3>
                <img src={headingDividerSmall} className="heading-divider-small" />
                <p>Words go here...</p>
              </div>
            </div>
          </div>
          <div className="button-container">
            <a className="button button-hollow">READ ALL POSTS</a>
          </div>
        </div>*/}
        <div id="team" className="landing-team landing-section  container">
          <Heading text="The Team" />
          <div className="team-content">
            <div className="team-member">
              <div className="team-member--image">
                <img className="avatar" alt='' src={yoniCohen} />
                <img className="dashed-circle" alt='' src={dashedCircleAvatar} />
                <div className="team-member--social">
                  <a href="https://www.twitter.com/yoni_cohen" target="_blank"><i className="icon icon-twitter"/></a>
                  <a href="https://www.linkedin.com/in/yonicohen/" target="_blank"><i className="icon icon-linkedin-in"/></a>
                </div>
              </div>
              <h3>Yoni Cohen</h3>
              <p>CEO</p>
              <div className="team-member--social"></div>
            </div>
            <div className="team-member">
              <div className="team-member--image">
                <img className="avatar" alt='' src={johnPotter} />
                <img className="dashed-circle" alt='' src={dashedCircleAvatar} />
                <div className="team-member--social">
                  <a href="https://twitter.com/johnmpotter" target="_blank"><i className="icon icon-twitter"/></a>
                  <a href="https://www.linkedin.com/in/johnpotter17/" target="_blank"><i className="icon icon-linkedin-in"/></a>
                  <a href="https://github.com/johnmpotter" target="_blank"><i className="icon icon-github"/></a>
                </div>
              </div>
              <h3>John Potter</h3>
              <p>Project Manager</p>
              <div className="team-member--social"></div>
            </div>
            <div className="team-member">
              <div className="team-member--image">
                <img className="avatar" alt='' src={zvonimirBaljak} />
                <img className="dashed-circle" alt='' src={dashedCircleAvatar} />
                <div className="team-member--social">
                  <a href="https://twitter.com/ZvoniBa" target="_blank"><i className="icon icon-twitter"/></a>
                  <a href="https://www.linkedin.com/in/zvonimir-baljak-85082a1a/" target="_blank"><i className="icon icon-linkedin-in"/></a>
                </div>
              </div>
              <h3>Zvonimir Baljak</h3>
              <p>Strategy & Economics</p>
              <div className="team-member--social"></div>
            </div>
            <div className="team-member">
              <div className="team-member--image">
                <img className="avatar" alt='' src={aaronLeibowitz} />
                <img className="dashed-circle" alt='' src={dashedCircleAvatar} />
                <div className="team-member--social">
                  <a href="https://twitter.com/A_Lebo" target="_blank"><i className="icon icon-twitter"/></a>
                  <a href="https://www.linkedin.com/in/aaron-leibowitz/" target="_blank"><i className="icon icon-linkedin-in"/></a>
                </div>
              </div>
              <h3>Aaron Leibowitz</h3>
              <p>Community</p>
              <div className="team-member--social"></div>
            </div>
            <div className="team-member">
              <div className="team-member--image">
                <img className="avatar" alt='' src={matejSerbec} />
                <img className="dashed-circle" alt='' src={dashedCircleAvatar} />
                <div className="team-member--social">
                  <a href="https://twitter.com/matejserbec" target="_blank"><i className="icon icon-twitter"/></a>
                  <a href="https://www.linkedin.com/in/matej-serbec-5504a858/" target="_blank"><i className="icon icon-linkedin-in"/></a>
                  <a href="https://github.com/mserbec" target="_blank"><i className="icon icon-github"/></a>
                </div>
              </div>
              <h3>Matej Serbec</h3>
              <p>Engineering</p>
              <div className="team-member--social"></div>
            </div>
            <div className="team-member">
              <div className="team-member--image">
                <img className="avatar" alt='' src={ariCohen} />
                <img className="dashed-circle" alt='' src={dashedCircleAvatar} />
                <div className="team-member--social">
                  <a href="https://twitter.com/cohen_ari" target="_blank"><i className="icon icon-twitter"/></a>
                  <a href="https://www.linkedin.com/in/ari-cohen-80066123/" target="_blank"><i className="icon icon-linkedin-in"/></a>
                </div>
              </div>
              <h3>Ari Cohen</h3>
              <p>Marketing</p>
              <div className="team-member--social"></div>
            </div>
            <div className="team-member">
              <div className="team-member--image">
                <img className="avatar" alt='' src={samuelBauer} />
                <img className="dashed-circle" alt='' src={dashedCircleAvatar} />
                <div className="team-member--social">
                  <a href="https://www.linkedin.com/in/samuelbauer/" target="_blank"><i className="icon icon-linkedin-in"/></a>
                </div>
              </div>
              <h3>Samuel Bauer</h3>
              <p>Strategy</p>
            </div>
            <div className="team-member">
              <div className="team-member--image">
                <img className="avatar" alt='' src={janeLevy} />
                <img className="dashed-circle" alt='' src={dashedCircleAvatar} />
                <div className="team-member--social">
                  <a href="https://www.linkedin.com/in/jane-levy-1315723/" target="_blank"><i className="icon icon-linkedin-in"/></a>
                </div>
              </div>
              <h3>Jane Levy</h3>
              <p>Advisor</p>
            </div>
          </div>
        </div>
        <div className="bottom-cta">
          <div className="bottom-cta--container">
            <h4>Sign up for updates</h4>
            <div>
              <EmailFormContainer/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Page/Home/Home.js